import React, { useState } from 'react';
import { handbookById } from '../forms/Form1/pickerHooks';
import YearPickerModal from '../forms/Form2/YearPickerModal';

const FORM1_REFERENCE_CELL_OUTER = {
  minHeight: 60,
  height: 'auto',
  cursor: 'pointer',
  background: 'transparent',
};

const FORM1_REFERENCE_FIELD_INNER = {
  border: 'none',
  outline: 'none',
  resize: 'none',
  background: 'none',
  borderRadius: '0',
  minHeight: 60,
  height: 'auto',
  textAlign: 'center',
  width: '100%',
  overflow: 'hidden',
  padding: '6px 0',
  boxSizing: 'border-box',
  cursor: 'pointer',
};

const QUARTER_OPTIONS = [
  { value: '1', label: '1 квартал' },
  { value: '2', label: '2 квартал' },
  { value: '3', label: '3 квартал' },
  { value: '4', label: '4 квартал' },
];

/**
 * Блок «Параметры отчёта»: субъект, филиал и период (месяц, либо квартал/год) — всё в одной строке.
 */
const GlpmReportParamsBlock = ({
  idPrefix,
  handbooks,
  glpmPickerFormData,
  openPicker,
  month,
  onMonthChange,
  maxMonth,
  showMonth = true,
  showQuarter = false,
  quarter,
  onQuarterChange,
  showYear = false,
  year,
  onYearChange,
}) => {
  const [showYearPicker, setShowYearPicker] = useState(false);

  const srfName = (() => {
    const handbook = handbookById(handbooks, 12);
    if (handbook?.references && glpmPickerFormData.srf) {
      const selectedOption = handbook.references.find(
        (r) => String(r.id) === String(glpmPickerFormData.srf).trim()
      );
      return selectedOption ? selectedOption.name : '';
    }
    return '';
  })();

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>
              Субъект РФ <span className="required">*</span>
            </th>
            {showMonth && (
              <th>
                Месяц <span className="required">*</span>
              </th>
            )}
            {showQuarter && (
              <th>
                Квартал <span className="required">*</span>
              </th>
            )}
            {showYear && (
              <th>
                Год <span className="required">*</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="coordinate-cell">
              <div
                className="reference-cell"
                onClick={() => openPicker('srf', 12)}
                style={FORM1_REFERENCE_CELL_OUTER}
              >
                <textarea
                  name={`${idPrefix}_srf`}
                  id={`${idPrefix}-srf`}
                  readOnly
                  tabIndex={-1}
                  value={srfName}
                  placeholder="☰"
                  title="Справочник «Субъект РФ»"
                  className={`form-control coordinate-field ${!String(glpmPickerFormData.srf || '').trim() ? 'required-field' : ''}`}
                  style={FORM1_REFERENCE_FIELD_INNER}
                />
              </div>
            </td>
            {showMonth && (
              <td className="coordinate-cell">
                <input
                  type="month"
                  name={`${idPrefix}_month`}
                  id={`${idPrefix}-month`}
                  value={month}
                  max={maxMonth}
                  onChange={(e) => onMonthChange(e.target.value)}
                  className={`form-control coordinate-field ${!month ? 'required-field' : ''}`}
                />
              </td>
            )}
            {showQuarter && (
              <td className="coordinate-cell">
                <select
                  name={`${idPrefix}_quarter`}
                  id={`${idPrefix}-quarter`}
                  value={quarter}
                  onChange={(e) => onQuarterChange(e.target.value)}
                  className={`form-control coordinate-field ${!quarter ? 'required-field' : ''}`}
                  style={{
                    width: '100%',
                    minHeight: 44,
                    padding: '8px 10px',
                    fontSize: '0.9rem',
                    textAlign: 'center',
                    boxSizing: 'border-box',
                  }}
                >
                  <option value="">— Выберите —</option>
                  {QUARTER_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </td>
            )}
            {showYear && (
              <td className="coordinate-cell">
                <div
                  className="reference-cell"
                  onClick={() => setShowYearPicker(true)}
                  title="Выбрать год"
                  style={FORM1_REFERENCE_CELL_OUTER}
                >
                  <textarea
                    name={`${idPrefix}_year`}
                    id={`${idPrefix}-year`}
                    readOnly
                    tabIndex={-1}
                    value={year ? String(year) : ''}
                    placeholder="☰"
                    className={`form-control coordinate-field ${!year ? 'required-field' : ''}`}
                    style={FORM1_REFERENCE_FIELD_INNER}
                  />
                </div>
              </td>
            )}
          </tr>
        </tbody>
      </table>

      {showYear && (
        <YearPickerModal
          showYearPicker={showYearPicker}
          displayData={{ glu: year ? String(year) : '' }}
          selectYear={(y) => {
            onYearChange(y);
            setShowYearPicker(false);
          }}
          closeYearPicker={() => setShowYearPicker(false)}
        />
      )}
    </>
  );
};

export default GlpmReportParamsBlock;
